import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { FaFileExcel } from 'react-icons/fa';
import { Dialog } from '@material-ui/core';

import api from '~/services/api';

import DialogOptionButton from '~/components/Buttons/DialogOption';
import Select from '~/components/Select';

import { Container, Icon, Title, Subtitle, Error } from './styles';

interface IReportProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const RebateBalancesReport: React.FC<IReportProps> = ({
  isOpen,
  setIsOpen,
}: IReportProps) => {
  const [quarters, setQuarters] = useState<{ id: string; code: string }[]>();
  const [quarterId, setQuarterId] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const loadQuarters = async () => {
      await api.get('/quarters/all').then(response => {
        setQuarters(response.data);
      });
    };

    loadQuarters();
  }, []);

  const handleClose = () => {
    setError('');
    setIsOpen(false);
  };

  function delay(ms: number): unknown {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const handleDownload = (filename: string) => {
    const link = document.createElement('a');

    link.href = `${process.env.REACT_APP_API_URL}/reports/${filename}`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const handleGenerate = async () => {
    setError('');

    let filenameReceived = '';

    await api
      .get(`/rebatebalances/report?quarter_id=${quarterId}`)
      .then(response => {
        filenameReceived = response.data.filename;
      });

    if (filenameReceived !== '') {
      handleDownload(filenameReceived);

      handleClose();

      await delay(2000);

      api.delete(`/rebatebalances/report/${filenameReceived}`);
    } else {
      setError('Não foi possível gerar o relatório');
    }
  };

  return (
    <Dialog open={isOpen}>
      <Container>
        <Icon>
          <FaFileExcel size={60} />
        </Icon>

        <Title>Geração de Relatório</Title>

        <Subtitle>Selecione a opção desejada</Subtitle>

        <div style={{ marginTop: 10 }}>
          <Select
            label="Trimestres"
            options={quarters?.map(q => ({
              value: q.id,
              label: q.code,
            }))}
            loading={!quarters}
            onSet={(e: any) => {
              setQuarterId(e.value);
              setError('');
            }}
          />
        </div>

        <div
          style={{
            marginTop: '1rem',
            display: 'flex',
            justifyContent: 'center',
            columnGap: 20,
            cursor: 'pointer',
          }}
        >
          <DialogOptionButton
            label="Gerar"
            optionType="report"
            onClick={() => handleGenerate()}
          />

          <DialogOptionButton label="Fechar" onClick={() => handleClose()} />
        </div>

        <Error>{error}</Error>
      </Container>
    </Dialog>
  );
};

export default RebateBalancesReport;
